import Root from 'components/Root';
import React from 'react';
import ReactDOM from 'react-dom';

ReactDOM.render(<Root />, document.getElementById('root'));
